import { render, staticRenderFns } from "./ManageForm.vue?vue&type=template&id=3c13f8d1&scoped=true&"
import script from "./ManageForm.vue?vue&type=script&lang=ts&"
export * from "./ManageForm.vue?vue&type=script&lang=ts&"
import style0 from "./ManageForm.vue?vue&type=style&index=0&id=3c13f8d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13f8d1",
  null
  
)

export default component.exports